/* Kava Nectar PDP hero buy-box behavior.
   Plain JS (not Liquid-processed) so money-format placeholders survive.
   Initializes every .kava-hero on the page; reads data from the embedded
   JSON script tag and data-* attributes. */
(function () {
  function initHero(root) {
    if (root.dataset.kavaInit) return;
    root.dataset.kavaInit = '1';

    var dataEl = root.querySelector('[data-kava-hero-data]');
    var DATA = {};
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) {}
    var variants = DATA.variants || [];
    var moneyFormat = DATA.moneyFormat || '${{amount}}';
    var AMT = /\{\{\s*amount\s*\}\}/;
    var AMT_NO_DEC = /\{\{\s*amount_no_decimals\s*\}\}/;
    var atcLabel = root.getAttribute('data-atc-label') || 'Add to Cart';

    function money(cents) {
      var v = (cents / 100).toFixed(2);
      var parts = v.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var amount = parts.join('.');
      var noDec = parts[0];
      if (AMT.test(moneyFormat)) return moneyFormat.replace(AMT, amount);
      if (AMT_NO_DEC.test(moneyFormat)) return moneyFormat.replace(AMT_NO_DEC, noDec);
      return '$' + amount;
    }
    function variantById(id) { return variants.filter(function (v) { return v.id == id; })[0]; }

    var els = {
      variantInput: root.querySelector('[data-variant-input]'),
      planInput: root.querySelector('[data-plan-input]'),
      priceMain: root.querySelector('[data-price-main]'),
      priceWas: root.querySelector('[data-price-was]'),
      oneTimePrice: root.querySelector('[data-onetime-price]'),
      oneTimeWas: root.querySelector('[data-onetime-was]'),
      oneTimeServing: root.querySelector('[data-onetime-serving]'),
      subServing: root.querySelector('[data-sub-serving]'),
      subDiscount: root.querySelector('[data-sub-discount]'),
      subSavePerk: root.querySelector('[data-sub-save-perk]'),
      qty: root.querySelector('[data-qty]'),
      atc: root.querySelector('[data-atc]'),
      atcLabel: root.querySelector('[data-atc-label]'),
      soldoutNote: root.querySelector('[data-soldout-note]'),
      main: root.querySelector('.kava-hero__main img')
    };

    // Default to Subscribe when a subscription is available.
    var hasSub = !!root.querySelector('.kava-hero__opt[data-mode="subscribe"]');
    var state = {
      variantId: els.variantInput ? els.variantInput.value : (variants[0] && variants[0].id),
      mode: 'onetime',
      cadence: null // selling-plan NAME; the actual plan id is resolved per variant
    };

    // Default cadence = monthly (every 4 weeks); the frequency picker was removed.
    (function () {
      var v0 = variantById(state.variantId);
      if (v0 && v0.plans && v0.plans.length) {
        var monthly = v0.plans.filter(function (p) { return /month/i.test(p.name); })[0];
        state.cadence = (monthly || v0.plans[0]).name;
      }
    })();

    // Each variant carries its own plans (different sizes can live in different
    // selling-plan groups), so resolve by cadence name and fall back to the
    // variant's first available plan.
    function planFor(v) {
      if (!v || !v.plans || !v.plans.length) return null;
      var byName = v.plans.filter(function (p) { return p.name === state.cadence; })[0];
      return byName || v.plans[0];
    }

    function render() {
      var v = variantById(state.variantId);
      if (!v) return;
      if (els.variantInput && String(els.variantInput.value) !== String(v.id)) {
        els.variantInput.value = v.id;
        // Let apps that watch the variant (Klaviyo back-in-stock) re-check it.
        els.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Sold out: hide purchase options + quantity, show the note, and let
      // Klaviyo's Notify Me button take the add-to-cart slot.
      root.classList.toggle('is-soldout', !v.available);
      if (els.soldoutNote) els.soldoutNote.hidden = !!v.available;

      if (v.image && els.main) {
        els.main.src = v.image;
        root.querySelectorAll('.kava-hero__thumb').forEach(function (t) {
          t.classList.toggle('is-active', v.imageId != null && t.dataset.mediaId === String(v.imageId));
        });
      }

      var oneTime = v.price;
      var compare = (v.compare && v.compare > 0) ? v.compare : 0;
      var plan = planFor(v);
      var isSub = state.mode === 'subscribe' && plan && plan.price != null;
      var current = isSub ? plan.price : oneTime;

      // One-time row: compare-at (MSRP) struck through + the regular price.
      if (els.oneTimePrice) els.oneTimePrice.textContent = money(oneTime);
      if (els.oneTimeWas) {
        if (compare > oneTime) { els.oneTimeWas.textContent = money(compare); els.oneTimeWas.hidden = false; }
        else { els.oneTimeWas.hidden = true; }
      }

      // Subscribe row: compare-at struck through + the discounted price.
      var subPrice = plan ? plan.price : oneTime;
      var subWas = compare > subPrice ? compare : (oneTime > subPrice ? oneTime : 0);
      if (els.priceMain) els.priceMain.textContent = money(subPrice);
      if (els.priceWas) {
        if (subWas) { els.priceWas.textContent = money(subWas); els.priceWas.hidden = false; }
        else { els.priceWas.hidden = true; }
      }

      // Subscription savings measured against the compare-at price (falls back to
      // the one-time price when no compare-at is set) drive the badge + perk.
      if (plan && plan.price != null && subWas > plan.price) {
        var subPct = Math.round((1 - plan.price / subWas) * 100);
        if (els.subDiscount) els.subDiscount.textContent = subPct + '% OFF';
        if (els.subSavePerk) els.subSavePerk.textContent = subPct + '% Discount on every order';
      }

      // Per-serving cost for each row (price ÷ cups).
      var cups = v.cups || 0;
      if (els.oneTimeServing) els.oneTimeServing.textContent = cups > 0 ? 'Only ' + money(Math.round(oneTime / cups)) + ' per serving' : '';
      if (els.subServing) els.subServing.textContent = cups > 0 ? 'Only ' + money(Math.round(subPrice / cups)) + ' per serving' : '';

      if (els.planInput) {
        if (isSub) { els.planInput.value = plan.id; els.planInput.disabled = false; }
        else { els.planInput.value = ''; els.planInput.disabled = true; }
      }

      if (els.atc) {
        els.atc.disabled = !v.available;
        if (els.atcLabel) {
          var qty = els.qty ? Math.max(1, parseInt(els.qty.value, 10) || 1) : 1;
          els.atcLabel.textContent = v.available
            ? atcLabel + ' · ' + money(current * qty)
            : 'Sold out';
        }
      }

      // Keep the sticky buy bar in sync with the selected size + price.
      // A button can opt into a dedicated data-meta-label (e.g. "20
      // single-serve sticks") so this line doesn't just repeat the edition
      // name already shown in the sticky title on pages where edition is
      // the only variant option; falls back to the visible size/edition
      // name otherwise (bags: "Makes 22 Cups").
      var stickyVar = document.querySelector('[data-sticky-variant]');
      if (stickyVar) {
        var activeBtn = root.querySelector('.kava-hero__size.is-active');
        var activeName = activeBtn && activeBtn.querySelector('.kava-hero__size-name');
        var metaLabel = activeBtn && activeBtn.dataset.metaLabel;
        if (metaLabel) stickyVar.textContent = metaLabel.trim();
        else if (activeName) stickyVar.textContent = activeName.textContent.trim();
      }
      var stickyBtn = document.querySelector('[data-kava-sticky-buy]');
      if (stickyBtn) {
        if (v.available) stickyBtn.innerHTML = 'Buy Now &middot; <span data-sticky-price></span>';
        else stickyBtn.textContent = 'Sold out \u00b7 Notify me';
        stickyBtn.dataset.soldout = v.available ? '' : '1';
      }
      var stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = money(current);
      var stickyImg = document.querySelector('[data-sticky-img]');
      if (stickyImg && v.image) stickyImg.style.backgroundImage = 'url(' + v.image + ')';

      // Products where edition is a variant option (e.g. stick packs), not a
      // separate product: keep the sticky bar's title in sync too.
      var stickyEdition = document.querySelector('[data-sticky-edition]');
      if (stickyEdition && v.title) {
        var editionMatch = v.title.match(/Classic|Relax|Balance/);
        if (editionMatch) stickyEdition.textContent = editionMatch[0];
      }
    }

    root.querySelectorAll('.kava-hero__thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('.kava-hero__thumb').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        if (els.main && t.dataset.full) els.main.src = t.dataset.full;
      });
    });

    root.querySelectorAll('.kava-hero__size').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('.kava-hero__size').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-checked', 'false'); });
        b.classList.add('is-active'); b.setAttribute('aria-checked', 'true');
        state.variantId = b.dataset.variant;
        render();
      });
    });

    root.querySelectorAll('.kava-hero__opt').forEach(function (p) {
      p.addEventListener('click', function () {
        root.querySelectorAll('.kava-hero__opt').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-checked', 'false'); });
        p.classList.add('is-active'); p.setAttribute('aria-checked', 'true');
        state.mode = p.dataset.mode;
        render();
      });
    });

    function qVal() { return Math.max(1, parseInt(els.qty.value, 10) || 1); }
    var dec = root.querySelector('[data-qty-dec]'), inc = root.querySelector('[data-qty-inc]');
    if (dec) dec.addEventListener('click', function () { els.qty.value = Math.max(1, qVal() - 1); render(); });
    if (inc) inc.addEventListener('click', function () { els.qty.value = qVal() + 1; render(); });
    if (els.qty) els.qty.addEventListener('input', render);

    var form = root.querySelector('.kava-hero__form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var sel = variantById(state.variantId);
        if (!sel || !sel.available) return;
        if (els.atc) { els.atc.disabled = true; els.atc.classList.add('is-loading'); }
        var body = { id: Number(state.variantId), quantity: qVal() };
        var subPlan = planFor(variantById(state.variantId));
        if (state.mode === 'subscribe' && subPlan) body.selling_plan = Number(subPlan.id);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        }).then(function () {
          // Refresh the theme's cart sections + count.
          document.dispatchEvent(new CustomEvent('theme:update:cart', { bubbles: true }));
          // Open the Shapes modal cart. Its ModalCart listener is bound to
          // document.body, so the event must be dispatched on body (events
          // bubble up, not down) for the drawer to open on add.
          document.body.dispatchEvent(new CustomEvent('shapes:cart:afteradditem', { bubbles: true }));
        }).catch(function () {
          window.location.href = '/cart';
        }).finally(function () {
          if (els.atc) { els.atc.disabled = false; els.atc.classList.remove('is-loading'); }
        });
      });
    }

    render();
    updateReviewCount(root);
  }

  // Pull the live Okendo review count (server-rendered into a script blob),
  // round down to the nearest 100, and update the reviews link + any
  // [data-reviews-count] placeholders across the page (proof, reviews, etc.).
  function updateReviewCount(root) {
    var link = root.querySelector('[data-reviews-link]');
    var countEls = document.querySelectorAll('[data-reviews-count]');
    if (!link && !countEls.length) return;
    var count = null;
    var scripts = document.querySelectorAll('script:not([src])');
    for (var i = 0; i < scripts.length; i++) {
      var m = scripts[i].textContent.match(/"reviewCount"\s*:\s*(\d+)/);
      if (!m) m = scripts[i].textContent.match(/"ratingAndReviewCount"\s*:\s*(\d+)/);
      if (m) { count = parseInt(m[1], 10); break; }
    }
    if (count && count > 0) {
      var rounded = count >= 100 ? Math.floor(count / 100) * 100 : count;
      if (link) {
        var suffix = link.getAttribute('data-reviews-suffix') || 'verified reviews';
        link.textContent = rounded + '+ ' + suffix;
      }
      for (var j = 0; j < countEls.length; j++) { countEls[j].textContent = rounded; }
    }
  }

  function init() { document.querySelectorAll('.kava-hero').forEach(initHero); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
